import React, { Component } from "react";
import LearningCategory from "./LearningCategory/LearningCategory";
import Aux from "../../../../hoc/Auxilliary";
import { getSubcategories } from "../../../../data-service";
import Spinner from "../../Common/Spinner/Spinner";
import * as CONSTANT from "../../../../constants";

class LearningCategories extends Component {
  state = {
    subcategories: [],
    showSpinner: false
  };
  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }
  componentDidMount() {
    this.showSpinner(true);
    getSubcategories()
      .then(response => {
        this.showSpinner(false);
        this.setState({ subcategories: response.data });
      })
      .catch(error => {
        this.showSpinner(false);
        this.props.showError(error);
      });
  }
  render() {
    const subCategoriesHtml = this.state.subcategories.map(subcategory => {
      return (
        <LearningCategory
          key={subcategory.Id}
          title={subcategory.Name}
          imagepath={`../${subcategory.ImagePath}`}
          url={`/learning/${subcategory.Id}`}
          categoryid={CONSTANT.LearningId}
          isenabled={subcategory.IsEnabled}
        />
      );
    });
    return (
      <Aux>
        <Spinner showSpinner={this.state.showSpinner} />
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12">
              <div className="row choose_video_bg01">
                <div className="container">
                  <div className="col-xs-12">
                    <div className="row">
                      <div className="choose_video_gallery">
                        <ul>{subCategoriesHtml}</ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="bg">
          <img src="images/tf_choose_video_image01.jpg" alt="" />
        </div>
      </Aux>
    );
  }
}

export default LearningCategories;



// WEBPACK FOOTER //
// ./src/containers/User/Learning/LearningCategories/LearningCategories.js